import { Roles, type Role } from "../../auth/roles";
import type { AreaRoute } from "./areaRoute";
import { lazyPage } from "../../lib/lazyPage";
const MorningBriefPage = lazyPage(() => import("../supply/MorningBriefPage"), "MorningBriefPage");
const PurchasingPage = lazyPage(() => import("../supply/PurchasingPage"), "PurchasingPage");
const ShippingPage = lazyPage(() => import("../supply/ShippingPage"), "ShippingPage");
const HuddlePage = lazyPage(() => import("../supply/HuddlePage"), "HuddlePage");
const PurchasingWorkspacePage = lazyPage(() => import("../purchasing/PurchasingWorkspacePage"), "PurchasingWorkspacePage");
const PurchasingRequestPage = lazyPage(() => import("../purchasing/PurchasingRequestPage"), "PurchasingRequestPage");
const WorkOrderRouterDocument = lazyPage(() => import("../purchasing/WorkOrderRouterDocument"), "WorkOrderRouterDocument");
const PackingListPage = lazyPage(() => import("../purchasing/PackingListPage"), "PackingListPage");

// Supply chain area (release 0.4.2, D-O56) and Purchasing workspace (D-O67):
// Shipping (Logistics), Purchasing view, rules-written Morning Brief, and the Purchasers' workspace & digital Work Order Router.

/** Who sees the Shipping (Logistics) view. */
export const ShippingReaders: readonly Role[] = [
  Roles.ShippingManager,
  Roles.OperationsManager,
  Roles.Planner,
  Roles.PlantManager,
  Roles.Executive,
  Roles.Admin
];

/** Who sees the Purchasing view (/shop-floor/purchasing). */
export const PurchasingReaders: readonly Role[] = [
  Roles.PurchasingManager,
  Roles.Purchasing,
  Roles.OperationsManager,
  Roles.Planner,
  Roles.Admin
];

/** Who sees the Purchasing workspace and digital Work Order Router (/purchasing, /purchasing/requests/:key, D-O67). */
export const PurchasingWorkspaceReaders: readonly Role[] = [
  Roles.Purchasing,
  Roles.PurchasingManager,
  Roles.OperationsManager,
  Roles.Planner,
  Roles.Admin
];

/** Release 1.20.0 (O-R226): who sees the Morning Huddle (matches the API's HuddleReaders). */
export const HuddleReaders: readonly Role[] = [
  Roles.OperationsManager,
  Roles.Planner,
  Roles.ShopSupervisor,
  Roles.OperationsViewer,
  Roles.PlantManager,
  Roles.Executive,
  Roles.ShippingManager,
  Roles.Logistics,
  Roles.Purchasing,
  Roles.PurchasingManager,
  Roles.EngineeringManager,
  Roles.Quality,
  Roles.Admin
];

export {
  ShippingPage,
  PurchasingPage,
  MorningBriefPage,
  HuddlePage,
  PurchasingWorkspacePage,
  PurchasingRequestPage,
  WorkOrderRouterDocument,
  PackingListPage
};

export const supplyRoutes: AreaRoute[] = [
  {
    // Release 1.20.0 (O-R226): the interactive Morning Huddle (Stand-Up Huddle Mode).
    path: "/huddle",
    allow: HuddleReaders,
    element: <HuddlePage />
  },
  {
    path: "/purchasing",
    allow: PurchasingWorkspaceReaders,
    element: <PurchasingWorkspacePage />
  },
  {
    path: "/purchasing/requests/:key",
    allow: PurchasingWorkspaceReaders,
    element: <PurchasingRequestPage />
  },
  {
    path: "/purchasing/requests/:key/router",
    allow: PurchasingWorkspaceReaders,
    element: <WorkOrderRouterDocument />
  },
  {
    // Release 1.7.0 (D-O141): the OSP vendor packing list.
    path: "/purchasing/packing-lists/:id",
    allow: PurchasingWorkspaceReaders,
    element: <PackingListPage />
  }
];